import { useContext } from "react";
import { ChatContext } from "../../contexts/ChatContext";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AssistantIcon from "@mui/icons-material/Assistant";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";

export default function ChatHeader({ showClose = true }) {
  const { setIsOpen, resetChat, isPinned, setIsPinned } =
    useContext(ChatContext);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 2,
        bgcolor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AssistantIcon />
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
          }}
        >
          Support Assistant
        </Typography>
      </Box>
      <Box>
        <IconButton
          size="small"
          onClick={resetChat}
          sx={{ color: "primary.contrastText" }}
          aria-label="New conversation"
          title="New conversation"
        >
          <RestartAltIcon fontSize="small" />
        </IconButton>
        {showClose && (
          <IconButton
            size="small"
            onClick={() => setIsPinned((prev) => !prev)}
            sx={{
              color: "primary.contrastText",
              display: { xs: "none", sm: "inline-flex" },
            }}
            aria-label={isPinned ? "Unpin chat" : "Pin chat"}
            title={isPinned ? "Unpin chat" : "Pin chat"}
          >
            {isPinned ? (
              <PushPinIcon fontSize="small" />
            ) : (
              <PushPinOutlinedIcon fontSize="small" />
            )}
          </IconButton>
        )}
        {showClose && (
          <IconButton
            size="small"
            onClick={() => setIsOpen(false)}
            sx={{ color: "primary.contrastText" }}
            aria-label="Close chat"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
